@if (enabled()) {
  <div class="ezri-launcher-root" [class.ezri-beside-notes]="besideNotes">
    @if (!open()) {
      <button #launcher type="button" class="ezri-fab" id="ezri-launcher"
              (click)="openPanel()"
              aria-haspopup="dialog" [attr.aria-expanded]="open()"
              [attr.aria-label]="'assistant.open' | translate"
              [attr.title]="'assistant.open' | translate">
        <svg class="ezri-stars" viewBox="0 0 24 24" aria-hidden="true"><path class="ezri-mark-star ezri-mark-star-big" d="M11.5 9.5L9 4 6.5 9.5 1 12l5.5 2.5L9 20l2.5-5.5L17 12l-5.5-2.5z"/><path class="ezri-mark-star ezri-mark-star-top" d="M19 9l1.25-2.75L23 5l-2.75-1.25L19 1l-1.25 2.75L15 5l2.75 1.25L19 9z"/><path class="ezri-mark-star ezri-mark-star-bottom" d="M19 15l-1.25 2.75L15 19l2.75 1.25L19 23l1.25-2.75L23 19l-2.75-1.25L19 15z"/></svg>
        <span class="ezri-fab-label" aria-hidden="true">Ezri</span>
      </button>
    } @else {
      <app-assistant-chat class="ezri-panel-host" [autoFocus]="focusOnOpen()"
                          [receipts]="receipts()" [demo]="isDemo()"
                          [monthlyMessagesLeft]="config()?.monthlyMessagesLeft ?? null"
                          (closed)="closePanel()"></app-assistant-chat>
    }
  </div>
}
